<!--领导驾驶舱过滤组件-->
<template>
    <div class="filterConditions-box">
        <div class="filterConditions">
            <van-popup
                class="filter-pop"
                position="right"
                v-model="visible"
                @close="hidePop"
            >
                <div class="head">
                    <span class="name">筛选</span>
                    <a class="close-filter-pop" @click="hidePop">取消</a>
                    <a class="sure-filter-pop" @click="handleSure">确定</a>
                </div>
                <div class="filter-contain">
                    <div class="filter-box">
                        <h1>区域</h1>
                        <ul>
                            <li @click="selectAll(2)" :class="{'active':checkAll.includes(2)|| !result.yun_yq_id.length}">
                                全部
                            </li>
                            <li
                                v-for="(item,index) in yun_yq_list"
                                :class="{'active':result.yun_yq_id.includes(item.id)}"
                                :key="item.id+index"
                                @click="handleSelectItem(item)"
                            >
                                {{ item.org_shortname }}
                            </li>
                        </ul>
                    </div>
                    <div class="filter-box" v-show="pian_q_list.length>0">
                        <h1>片区</h1>
                        <ul>
                            <li @click="selectAll(3)" :class="{'active':checkAll.includes(3)|| !result.pian_q_id.length}">
                                全部
                            </li>
                            <li
                                v-for="(item,index) in pian_q_list"
                                :key="item.id+index"
                                :class="{'active':result.pian_q_id.includes(item.id)}"
                                @click="handleSelectItem(item)"
                            >
                                {{ item.org_shortname }}
                            </li>
                        </ul>
                    </div>
                    <div class="filter-box" v-show="qi_y_list.length>0">
                        <h1>平台企业</h1>
                        <ul>
                            <li @click="selectAll(5)" :class="{'active':checkAll.includes(5)|| !result.qi_y_id.length}">
                                全部
                            </li>
                            <li
                                v-for="(item,index) in qi_y_list"
                                :key="item.id+index"
                                :class="{'active':result.qi_y_id.includes(item.id)}"
                                @click="handleSelectItem(item)"
                            >
                                {{ item.org_shortname }}
                            </li>
                        </ul>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>
<script>
export default {
    name: 'filter-conditions',
    data() {
        return {
            defultOrgId: 'OT000001',
            visible: false,
            result: {
                startDate: '',
                endDate: '',
                yun_yq_id: [], // 运营区id
                pian_q_id: [], // 片区id
                qi_y_id: [], // 企业id
            },
            checkName: '',
            yun_yq_list: [], // 运营区列表
            pian_q_list: [], // 片区列表
            qi_y_list: [], // 企业列表
            checkAll: [2, 3, 5], // 选择全部 1->运营区 2->片区  3->企业

            allList: [], // 数据集合
            orgTree1: {}, // 数据关联映射
            orgTree2: {}, // 数据关联映射
        };
    },
    props: {
        showFilterPop: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        showFilterPop(val) {
            this.visible = val;
        },
    },
    created() {
        this.initOrgTree();
    },
    methods: {
        // 初始化组织树
        async initOrgTree() {
            const orgList1 = await this.getOrgList(this.defultOrgId, 2);
            this.yun_yq_list = orgList1.List;
            this.yun_yq_list.forEach(item => {
                this.orgTree1[item.id] = [];
            });
            const orgList2 = (await this.getOrgList(this.defultOrgId, 3)).List;
            const orgList3 = (await this.getOrgList(this.defultOrgId, 5)).List;
            orgList2.forEach(item => {
                if (!this.orgTree2[item.parent_id]) {
                    this.orgTree2[item.parent_id] = [];
                }
                this.orgTree1[item.parent_id].push(item);
                this.orgTree2[item.id] = [];
            });
            orgList3.forEach(item => {
                const pids = item.allparent_id.split(',');
                pids.forEach(pid => {
                    if (this.orgTree2[pid]) {
                        this.orgTree2[pid].push(item);
                    }
                });
            });
        },
        // 隐藏
        hidePop() {
            this.$emit('update:showFilterPop', false);
        },
        // 获取 org信息
        getOrg(org_id, org_type ) {
            this.getOrgList(org_id, org_type).then(data => {
                if (org_type === 2) {
                    this.yun_yq_list.push(...data.List);
                } else if (org_type === 3) {
                    this.pian_q_list.push(...data.List);
                } else if (org_type === 5) {
                    this.qi_y_list.push(...data.List);
                }
                this.orgTree[org_id] = data.List;
            });
        },
        // 选择筛选项目
        handleSelectItem(item) {
            this.checkAll.splice(this.checkAll.indexOf(item.org_type), 1);
            switch (item.org_type) {
                case 2: // 运营区
                    this.selectedOrRemove(this.result.yun_yq_id, item);
                    break;
                case 3: // 片区
                    this.selectedOrRemove(this.result.pian_q_id, item);
                    break;
                case 5: // 公司
                    this.selectedOrRemove(this.result.qi_y_id, item);
                    break;
            }
        },
        // 选择或取消选择
        selectedOrRemove(arr = [], item) {
            const index = arr.indexOf(item.id);
            if (index !== -1) {
                arr.splice(index, 1);
                this.removeList(item);
            } else {
                arr.push(item.id);
                this.appendList(item);
            }
        },
        appendList(item) {
            const org_type = item.org_type;
            if (org_type === 2) {
                this.pian_q_list.push(...this.orgTree1[item.id]);
            } else if (org_type === 3) {
                this.qi_y_list.push(...this.orgTree2[item.id]);
            }
        },
        // 取消选择移除下级列表
        removeList(item) {
            const org_type = item.org_type;
            if (org_type === 2) {
                this.pian_q_list = this.pian_q_list.filter(data => !data.allparent_id.includes(item.id));
                this.result.pian_q_id.splice(this.result.pian_q_id.indexOf(item.id), 1);
                this.qi_y_list = [];
                this.result.qi_y_id = [];
            } else if (org_type === 3) {
                this.qi_y_list = this.qi_y_list.filter(data => !data.allparent_id.includes(item.id));
                this.result.qi_y_id.splice(this.result.qi_y_id.indexOf(item.id), 1);
            }
        },

        selectAll(type) {
            if (type === 2) {
                this.result.yun_yq_id = [];
                this.result.pian_q_id = [];
                this.result.qi_y_id = [];
                this.pian_q_list = [];
                this.qi_y_list = [];
            } else if (type === 3) {
                this.result.pian_q_id = [];
                this.result.qi_y_id = [];
                this.qi_y_list = [];
            } else if (type === 5) {
                this.result.qi_y_id = [];
            }
            const index = this.checkAll.indexOf(type);
            if (index !== -1) { // 已选择，取消选择
                this.checkAll.splice(index, 1);
            } else {
                this.checkAll.push(type);
            }
        },
        // 确认选择
        handleSure() {
            const data = {};
            data.yun_yq_id = this.result.yun_yq_id.join();
            data.pian_q_id = this.result.pian_q_id.join();
            data.qi_y_id = this.result.qi_y_id.join();
            this.$emit('sureBack', data);
            this.hidePop();
        },
        // 通过类型获取指定组织下所有指定类型的组织、
        getOrgList(org_id, org_type) {
            const url = `/interfaceApi/basicplatform/orgtree/orgtype/${org_id}/${org_type}?page=1&row=9999`;
            return this.$axios.get(url);
        },
    },
};
</script>

<style scoped lang="stylus">
.filterConditions-box
    .selectedName
        width 100%
        height: 42rpx;
        line-height 42rpx;
        padding-left 15rpx;
        background: rgba(2, 23, 50, 0.98);
        box-shadow: 0px 2rpx 10rpx 0px rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 14rpx;
        color rgba(255,255,255,0.6);
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        span
            color #0096F8;
    .filterConditions
        display flex
        .filter-pop
            width: 300rpx;
            height: 100vh;
            background: #0E1D33;
            box-shadow: -2rpx 0px 10rpx 0px rgba(0, 0, 0, 0.7);
            .head
                width: 100%;
                height: 64rpx;
                background: #072653;
                display flex
                justify-content center
                align-items center
                position relative;
                .name
                    font-size: 18rpx;
                    color: #fff;
                .close-filter-pop
                    position absolute
                    top 24rpx
                    left 16rpx
                    font-size: 14rpx;
                    color: rgba(255,255,255,0.6);
                .sure-filter-pop
                    position absolute
                    top 24rpx
                    right 16rpx
                    font-size: 14rpx;
                    color: rgba(255,255,255,0.6);
            .filter-contain
                height calc(100vh - 64rpx)
                overflow-y auto
            .filter-box
                padding 12rpx;
                h1
                    font-size 14px;
                    color #fff;
                ul
                    display flex
                    flex-wrap wrap
                    padding-top 5rpx;
                    li
                        display flex
                        justify-content center
                        align-items center
                        margin 4rpx 3rpx;
                        width: 84rpx;
                        height: 30rpx;
                        background: #162945;
                        border-radius: 4rpx;
                        border: 1px solid #1F375A;
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        font-size 14rpx
                        color: #5695F1;
                        &.active
                            background: linear-gradient(135deg, #3A96FE 0%, #40B6FF 100%);
                            color #fff;
        .line
            width: 20rpx;
            height: 2px;
            background: rgba(255, 255, 255, 0.2);
        .time
            width 80rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            position relative
            input
                width 130rpx
                height 30rpx
                border none
                text-indent 30rpx
                background: transparent;
                font-size 14rpx;
                color:#fff;
                font-family: Technology-Regular, Technology;
            &:before
                line-height 30rpx
                font-size 16rpx
                color #0096F8
                position absolute
                left 5rpx
</style>
